"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.text2narufile = function (text) { return ({ text: text, lines: getLines(text) }); };
function iterLines(narufile) {
    var e_1, _a, lastLineOffset, _b, _c, lineOffset, e_1_1;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                lastLineOffset = 0;
                _d.label = 1;
            case 1:
                _d.trys.push([1, 6, 7, 8]);
                _b = __values(narufile.lines), _c = _b.next();
                _d.label = 2;
            case 2:
                if (!!_c.done) return [3 /*break*/, 5];
                lineOffset = _c.value;
                return [4 /*yield*/, narufile.text.substring(lastLineOffset, lineOffset)];
            case 3:
                _d.sent();
                lastLineOffset = lineOffset;
                _d.label = 4;
            case 4:
                _c = _b.next();
                return [3 /*break*/, 2];
            case 5: return [3 /*break*/, 8];
            case 6:
                e_1_1 = _d.sent();
                e_1 = { error: e_1_1 };
                return [3 /*break*/, 8];
            case 7:
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
                return [7 /*endfinally*/];
            case 8: return [4 /*yield*/, narufile.text.substr(lastLineOffset)];
            case 9:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
exports.iterLines = iterLines;
function getText(file, range) {
    if (!range)
        return file.text;
    return file.text.substr(range.offset, range.length);
}
exports.getText = getText;
function getPosition(file, offset) {
    var row = bisect(file.lines, offset);
    var col = (row === 0) ? 0 : offset - file.lines[row - 1];
    return { col: col, row: row };
}
exports.getPosition = getPosition;
function getLines(text) {
    var result = [];
    for (var i = 0; i < text.length; ++i) {
        var char = text[i];
        switch (char) {
            case '\r': if (text[i + 1] === '\n')
                continue;
            case '\n':
            case '\x85':
            case '\u2028':
            case '\u2029':
                result.push(i + 1);
                break;
        }
    }
    return result;
}
exports.getLines = getLines;
function bisect(a, x, lo, hi) {
    if (lo === void 0) { lo = 0; }
    if (hi === void 0) { hi = a.length; }
    while (lo < hi) {
        var mid = (lo + hi) >> 1;
        if (x < a[mid])
            hi = mid;
        else
            lo = mid + 1;
    }
    return lo;
}
